export default
    {
        path: '/auction/detail/apply',
        component: require('./index').default,
        parent: 'root',
        meta: {
            isLogin: true,
            title:'报名竞价'
        },
        name:'auctionApply'
    }
